import { ExtendCSS } from 'vcc-ui';

const MAX_COMPONENT_WIDTH = 400;

export const clickWrapper: ExtendCSS = ({ theme: { baselineGrid } }) => ({
  justifyContent: 'center',
  fromL: {
    marginLeft: baselineGrid * 4,
    height: 56,
  },
});

export const outerWrapper: ExtendCSS = {
  fromL: {
    flexDirection: 'row',
  },
};

export const selectWrapper: ExtendCSS = {
  maxWidth: MAX_COMPONENT_WIDTH,
  flexGrow: 1,
  untilM: {
    maxWidth: '100%',
  },
};
